import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter, Subject, takeUntil } from 'rxjs';
import { AuthserviceService } from '../@core/services/authservice.service';

@Component({
  selector: 'app-portal-layout',
  templateUrl: './portal-layout.component.html',
  styleUrls: ['./portal-layout.component.css'],
  standalone: false,
})
export class PortalLayoutComponent implements OnInit, OnDestroy {
  readonly spinnerName = 'portalLayoutSpinner';

  pageTitle = '';
  pageSubtitle = '';

  private readonly destroyed$ = new Subject<void>();
  private readonly routeTitles: Record<string, string> = {
    // Administración
    farmacias: 'Maestro de farmacias',
    paquetes: 'Productos activos por cliente',
    mapa: 'Mapa de clientes',
    'control-uso': 'Accesos al área de clientes',

    // Minerva
    sentinel: 'Sentinel - DataOps',
    argos: 'Argos - DataGraph',
    hermes: 'Hermes - FarmaIA',
    'hermes/gastos': 'Hermes � Gastos',
    'hermes/metadatos': 'Hermes � Metadatos',
    'hermes/entrenamiento': 'Hermes � Entrenamiento',

    // Panel de control
    'azure-key-vault': 'Azure Key Vault',
    'control-cargas-bbdd': 'Control de cargas de datos',
    'cargas-diarias': 'Sentinel - DataOps',
    datagraph: 'Argos - DataGraph',
    'control-calidad': 'Control de calidad de datos',
    'ordenes-sb': 'Aplicativo - Tareas de ejecución',
    'programacion-tareas-v2': 'Aplicativo - Calendario de tareas',
    logs: 'Logs',
    fingerprint: 'Fingerprint de seguridad',
    heartbeat: 'Heartbeat',
    anydesk: 'Credenciales AnyDesk',
    rmm: 'T\u00fanel RMM - equipos remotos',
    'tareas-motor': 'Tareas',
    'calendario-motor': 'Calendario',
    'logs-rmm': 'Logs de conexiones RMM',
    'rmm-verificar': 'Verificación de acceso a RMM',

    // Panel de control (old)
    'control-cargas': 'Control cargas (old)',
    ordenes: 'Órdenes (old)',
    'programacion-tareas': 'Calendario (old)',
    polling: 'Polling (old)',
    'control-cargas-parciales': 'Cargas parciales (old)',

    // Otras secciones
    usuarios: 'Gestión de usuarios y perfil',
    auditoria: 'Auditoría de conexiones RMM',
    fedicom: 'Credenciales Fedicom',
    'fedicom-descarga': 'Albaranes',
    whatsapp: 'Whatsapp',
    email: 'Email',
    'email/mailrelay-usage': 'MailRelay',
    estado: 'Estado',
    errores: 'Errores',
    'farmaia/costes': 'Hermes � Gastos',
    'farmaia/metadatos': 'Hermes � Metadatos',
    'farmaia/entrenamiento': 'Hermes � Entrenamiento',
    farmaia: 'Hermes - FarmaIA',
    vacaciones: 'Gestión de vacaciones',
  };

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthserviceService
  ) {}

  ngOnInit(): void {
    this.spinner.show(this.spinnerName);
    setTimeout(() => this.spinner.hide(this.spinnerName), 0);

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.updatePageMeta());

    this.updatePageMeta();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  get userLabel(): string {
    return this.auth.usuarioValue?.usuario || 'Usuario';
  }

  private updatePageMeta(): void {
    let currentRoute = this.route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    const data = currentRoute.snapshot.data;
    this.pageTitle = (data['title'] as string) || this.titleFromUrl(this.router.url);
    this.pageSubtitle = (data['subtitle'] as string) || '';
  }

  private titleFromUrl(url: string): string {
    const cleanUrl = url.split('?')[0].replace(/^\/+/, '');
    const routeKey = cleanUrl.split('/')[0] || 'farmacias';

    return this.routeTitles[cleanUrl] || this.routeTitles[routeKey] || 'Panel';
  }
}

